<template>
  <div>
    <div :class="s.bg"/>
    <div :class="s.wrapper">
      <img
        :class="s.logo"
        v-if="step !== 3"
        src="/img/logos/mitt_logo.png" alt="MITTのロゴ">
      
      <div v-if="flag.loading" :class="s.loading"></div>

      <!-- 最初表示 -->
      <div :class="s.content" v-if="step === 1">
        <div :class="s.top_text">
          <p class="fw-bold"><span>LINEで簡単に呼べるタクシー</span><span>MITT（ミット）</span><span>需要調査</span></p>
          <p><span>アンケートに答えて</span><span>地域タクシーを呼ぼう！</span></p>
        </div>
        <div
          @click="flag.started = true"
          :class="s.start_button">スタート</div>
      </div>

      <!-- 要望フォーム -->
      <div :class="s.content" v-else-if="step === 2">
        <!-- UserTypesの選択 -->
        <p class="fw-bold">属性をご回答ください。</p>
        <div :class="s.form">
          <div :class="s.select_btn_wrap">
            <button
              v-for="(type, i) in userTypes" :key="i"
              :class="[s.btn]"
              @click="selectUserType(type)">{{ type.label }}</button>
          </div>
        </div>
      </div>

      <!-- 要望 -->
      <div :class="s.content" v-else-if="step === 3">
        <p class="fw-bold">移動に関するニーズ<br>（複数回答可）</p>
        <div :class="s.form">
          <div :class="s.select_btn_wrap">
            <div
              v-for="(item, i) in needsItems" :key="i"
              :class="[s.btn, s.select_multiple, selectedNeeedsIds.includes(item.id) && s.selected]"
              @click="selectNeedsItems(item)">{{ item.label }}</div>
          </div>
          <div>
            <textarea
              v-model="needsMemo"
              name="" id="" rows="4" placeholder="その他・自由記述欄"></textarea>
          </div>
          <button
            :class="[s.btn]"
            @click="submitNeeds()">回答する</button>
        </div>
      </div>

      <!-- DONE -->
      <div :class="s.content" v-else-if="step === 100">
        <div :class="s.top_text">
          <p class="fw-bold">
            <span>アンケートにご回答</span>
            <span>ありがとうございまいした。</span>
          </p>
          <p>
            <span>調査の結果や</span><span>開始の際の</span><span>ご連絡は</span>
            <span>下記LINEアプリで</span><span>通知を受け取れます。</span>
          </p>
          <p>
            <span>ぜひご登録</span><span>ください！</span>
          </p>
        </div>
        <div :class="s.btns">
          <a
            :class="[s.btn, s.green]"
            href="https://lin.ee/Yg8rVQa">MITT LINE アプリ</a>
        </div>
      </div>

      <!-- error -->
      <div v-else>
        <p class="fw-bold">
          <span>処理中にエラーが発生しました。</span>
          <span>恐れ入りますが</span>
          <span>時間をおいて再度お試しください。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'Survey',
  mixins: [cf],
  data() {
    return {
      flag: {
        started: false,
        registed: false,
        posting: false,
        loading: false,
        selected: {
          userType: false,
          needsItems: false,
        },
      },
      acceptTags: [
        'kusatsu',
      ],
      tag: '',
      ageGroup: null,
      ageGroups: [
        { label: '選択してください', value: null },
        { label: '20歳未満', value: 'under_20' },
        { label: '20代', value: '20s' },
        { label: '30代', value: '30s' },
        { label: '40代', value: '40s' },
        { label: '50代', value: '50s' },
        { label: '60代', value: '60s' },
        { label: '70代', value: '70s' },
        { label: '80代以上', value: 'over_80' },
        { label: '回答しない', value: 'no_answer' },
      ],
      userType: null,
      userTypes: [
        { label: 'ビジター（観光客）', value: 'visitor' },
        { label: '地元事業者', value: 'local_business' },
        { label: '一般住民', value: 'resident' },
      ],
      selectedNeeedsIds: [],
      needsMemo: '',
      location: {
        lat: null,
        lng: null,
      },
    };
  },
  computed: {
    ...mapState(['helper']),
    needsItems() {
      return this.helper.master.mobilityInsights?.needsItems || [];
    },
    step() {
      if (!this.flag.started) return 1;
      if (!this.flag.selected.userType) return 2;
      if (!this.flag.selected.needsItems) return 3;
      if (this.flag.registed) return 100;
      return 999;
    },
    isReady() {
      return Boolean(this.ageGroup);
    },
  },
  mounted() {
    this.getLocation();
    this.initUserCode();
    const tag = this.$route.query?.tag || '';
    if (this.acceptTags.includes(tag)) this.tag = tag;
  },
  methods: {
    getLocation() {
      if (!navigator.geolocation) {
        console.log('Geolocation is not supported by this browser.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.location.lat = position.coords.latitude;
          this.location.lng = position.coords.longitude;
        },
        (error) => {
          console.log('Geolocation error:', error.message);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    },
    initUserCode() {
      const projectName = process.env.VUE_APP_PROJECTNAME;
      const ls = cf.getLocalStorage(projectName);
      if (ls?.mobility_insights_code) {
        this.code = ls.mobility_insights_code;
      } else {
        const randomCode = this.generateCode();
        const timeCode = this.formatTimestamp(new Date(), 'YYYYMMDD-HHmmssSS');
        this.code = `${timeCode}-${randomCode}`;
        cf.saveLocalStorage({ mobility_insights_code: this.code }, projectName);
      }
    },
    generateCode() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let code = '';
      for (let i = 0; i < 8; i += 1) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return code;
    },
    selectUserType(type) {
      this.userType = type.value;
      this.flag.selected.userType = true;
    },
    selectNeedsItems(item) {
      if (this.selectedNeeedsIds.includes(item.id)) {
        this.selectedNeeedsIds = this.selectedNeeedsIds.filter((id) => id !== item.id);
      } else {
        this.selectedNeeedsIds.push(item.id);
      }
    },
    submitNeeds() {
      this.flag.selected.needsItems = true;
      this.postInsights();
    },
    postInsights() {
      const data = {
        code: this.code,
        tag: this.tag || null,
        age_group: this.ageGroup,
        user_type: this.userType,
        needs_types: this.selectedNeeedsIds,
        needs_memo: this.needsMemo,
        ...this.location,
      };
      this.flag.loading = true;
      this.axios({
        method: 'POST',
        url: '/v1/mobilityInsight/create',
        data,
      })
        .then(() => {
          this.flag.registed = true;
        })
        .catch((e) => {
          console.log(e.response?.message || e);
          alert('送信処理中にに失敗しました。\n恐れ入りますが、再度送信してください。');
        })
        .finally(() => {
          this.flag.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.bg {
  position: fixed;
  z-index: 100;
  top: 0; left: 0;
  width: 100dvw;
  height: 100dvh;
  background-color: rgba(black, .5);
}
.wrapper {
  position: fixed;
  top: 50%; left: 50%;
  translate: -50% -50%;
  z-index: 1000;
  background-color: #ffffff;
  font-size: 16px;
  padding: 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  width: min(500px, 100dvw - 40px);
  max-height: calc(100dvh - 40px);
  margin: 0 auto;
  overflow-y: scroll;
}
.logo {
  $btnW: min(180px, 100dvw - 80px);
  width: $btnW;
}
.content {
  margin-top: 12px;
  width: 100%;
  p {
    margin: 0;
    font-size: 18px;
    span {
      white-space: nowrap;
    }
  }
  text-align: center;
  .top_text {
    p {
      margin-top: 16px;
      font-size: 18px;
    }
  }

  textarea {
    width: 100%;
    margin-top: 12px;
    border-radius: 10px;
    font-size: 16px;
    border-color: var(--border-gray);
    outline: none;
    padding: 12px;
  }
}
.start_button {
  $btnW: min(180px, 100dvw - 80px);
  width: $btnW;
  height: $btnW;
  background-color: var(--theme-blue);
  color: #ffffff;
  font-weight: bold;
  box-shadow: rgba(0, 0, 0, .25) 1px 1px 10px 2px;
  border-radius: 50%;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 32px auto 0;
}
.select {
  margin-top: 12px;
  width: 100%;
  border-color: var(--border-gray);
  border-radius: 0.375rem;
  padding: 12px;
  text-align: center;
  font-size: 16px;
  background-color: #ffffff;
  outline: none;
  appearance: none;
}
.form {
  margin-top: 24px;
  &_note {
    font-size: 14px;
  }
}
.btns {
  margin-top: 48px;
}
.btn {
  display: block;
  padding: 24px 12px;
  border-radius: 10px;
  background-color: var(--theme-blue);
  color: #ffffff;
  width: 100%;
  border: none;
  box-shadow: rgba(0, 0, 0, .25) 1px 1px 10px 2px;
  margin-top: 12px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;

  &.green {
    background-color: var(--line-green);
    border-color: var(--line-green);
  }

  &:disabled {
    cursor: auto;
    opacity: .6;
  }

  &.select_multiple {
    border: 3px solid transparent;
    background-color: #ffffff;
    color: var(--label-primary);
    &.selected {
      border-color: var(--theme-blue);
    }
  }
}
.loading {
  margin: 50px auto;
  border:4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--theme-blue);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation:spinner1 1.2s linear infinite
}
@keyframes spinner1{
  0% { transform:rotate(0) }
  100% { transform:rotate(360deg) }
}
</style>
